import "./grid-view-switch.scss";

import React, { useState } from "react";
import classNames from "classnames";

const GridViewSwitch = ({ onGridClick, onListClick }) => {
  const [view, setView] = useState("grid");

  return (
    <div className="grid-switch">
      <div
        className={classNames("grid-switch__button", {
          [`grid-switch__button--active`]: view === "grid",
        })}
        onClick={(e) => {
          setView("grid");
          onGridClick();
        }}
        aria-hidden="true"
      >
        <img
          src={require("assets/icons/view-grid.png").default}
          className="grid-switch__icon"
          alt=""
        />
      </div>
      <div
        className={classNames("grid-switch__button", {
          [`grid-switch__button--active`]: view === "list",
        })}
        onClick={(e) => {
          setView("list");
          onListClick();
        }}
        aria-hidden="true"
      >
        <img
          src={require("assets/icons/view-list.png").default}
          className="grid-switch__icon"
          alt=""
        />
      </div>
    </div>
  );
};

export default GridViewSwitch;
